import { CloseButton, Table } from '@mantine/core';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { useState } from 'react';
import { KeyedRow } from '../../../components/KeyedRow';
import { TableRowCollapsible } from '../../../components/TableRowCollapsible';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { formatToCurrency } from '../../../util/formatting';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { ProductTotalDto } from '../types/ProductTotalDto';

interface ProductRowProps {
	originalProduct: ProductTotalDto;
}

export function ProductTotalRow({ originalProduct }: ProductRowProps) {
	const [productOpen, setProductOpen] = useState(false);
	const [product, setProduct] = useState(originalProduct);
	return (
		<>
			<KeyedRow key={product.skuid}>
				<Table.Td>{undefinedCheck(product.skuid)}</Table.Td>
				<Table.Td>{undefinedCheck(product.branchName)}</Table.Td>
				<Table.Td>{undefinedCheck(product.name)}</Table.Td>
				<Table.Td>{product.qtySold}</Table.Td>
				<Table.Td>{formatToCurrency(product.grossSales)}</Table.Td>
				<Table.Td>{formatToCurrency(product.vat)}</Table.Td>
				<Table.Td>{formatToCurrency(product.discount)}</Table.Td>
				<Table.Td>{formatToCurrency(product.individualPrice)}</Table.Td>D
				<Table.Td>
					<CloseButton
						icon={
							!productOpen ? (
								<IconChevronDown {...defaultIconStyle} />
							) : (
								<IconChevronUp {...defaultIconStyle} />
							)
						}
						onClick={() => setProductOpen(!productOpen)}
					/>
				</Table.Td>
			</KeyedRow>
			<TableRowCollapsible isOpen={productOpen} columnRows={12}>
				<Table>
					<Table.Thead>
						<KeyedRow>
							<Table.Th>Jan</Table.Th>
							<Table.Th>Feb</Table.Th>
							<Table.Th>Mar</Table.Th>
							<Table.Th>Apr</Table.Th>
							<Table.Th>May</Table.Th>
							<Table.Th>Jun</Table.Th>
							<Table.Th>Jul</Table.Th>
							<Table.Th>Aug</Table.Th>
							<Table.Th>Sep</Table.Th>
							<Table.Th>Oct</Table.Th>
							<Table.Th>Nov</Table.Th>
							<Table.Th>Dec</Table.Th>
						</KeyedRow>
					</Table.Thead>
					<Table.Tbody>
						<KeyedRow>
							<Table.Td>{product.jan}</Table.Td>
							<Table.Td>{product.feb}</Table.Td>
							<Table.Td>{product.mar}</Table.Td>
							<Table.Td>{product.apr}</Table.Td>
							<Table.Td>{product.may}</Table.Td>
							<Table.Td>{product.jun}</Table.Td>
							<Table.Td>{product.jul}</Table.Td>
							<Table.Td>{product.aug}</Table.Td>
							<Table.Td>{product.sep}</Table.Td>
							<Table.Td>{product.oct}</Table.Td>
							<Table.Td>{product.nov}</Table.Td>
							<Table.Td>{product.dec}</Table.Td>
						</KeyedRow>
					</Table.Tbody>
				</Table>
			</TableRowCollapsible>
		</>
	);
}
